<template>
    <b-table
        id="indices"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum índice encontrado.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Guia Antigo <i class="filter" :class="!isEmpty(filtro.codGuia) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Guia Antigo', 'mascara', '', '##########', $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            <p class="text-right">
                <a href="#" class='link' @click="getGuiaAntigo(item.codGuia);">
                {{ item.codGuia }}
                </a>
            </p>
        </template>
        <template v-slot:head(2)="{ item }">
            Tipo de Requisição <i class="filter" :class="!isEmpty(filtro.tipoRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo de Requisição', 'checkbox', listaTipoRequisicao, null, $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            {{ item.tipoRequisicao }}
        </template>
        <template v-slot:head(3)="{ item }">
            Número do Processo <i class="filter" :class="!isEmpty(filtro.numeroProcesso) || filtro.filtrarNumeroProcesso == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número do Processo', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            {{ item.numProcesso }}
        </template>
        <template v-slot:head(4)="{ item }">
            Ano do Processo <i class="filter" :class="!isEmpty(filtro.anoProcesso) || filtro.filtrarAnoProcesso == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Ano do Processo', 'numerico', '', null, $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            <p class="text-right">
                {{ item.anoProcesso }}
            </p>
        </template>
        <template v-slot:head(5)="{ item }">
            CDA's <i class="filter" :class="!isEmpty(filtro.cda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDAs', 'mascara', '', '##########', $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            <p class="text-right">
                {{ item.cdas }}
            </p>
        </template>
        <template v-slot:head(6)="{ item }">
            Contribuinte <i class="filter" :class="!isEmpty(filtro.contribuinte) || filtro.filtrarContribuinte == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Contribuinte', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            {{ item.nomeInteressado }}
        </template>
        <template v-slot:head(7)="{ item }">
            Indicador EF (Sipro) <i class="filter" :class="!isEmpty(filtro.indicadorEf) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Indicador EF (Sipro)', 'checkbox', dados.listaIndicadorEf, null, $event)"></i>
        </template>
        <template v-slot:cell(7)="{ item }">
            {{ item.indicadorEf }}
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';
    import axios from 'axios';

export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'listaTipoRequisicao', 'filtro'],
    mixins: [ formatarMixins ],
    data() {
        return {
            dados: {
                listaIndicadorEf: [
                    {id: 0, nome: 'Execução Fiscal'},
                    {id: 1, nome: 'Ação Judicial'},
                    {id: 2, nome: 'Inexistente'},
                ],
            },
            guiaAntigo: null,
            urlApi: process.env.VUE_APP_ROOT_API,
            token: JSON.parse(this.$store.getters.getUser).access_token,
        }
    },
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                this.selecteds.push(item);
            } else {
                const index = this.selecteds.indexOf(item);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        async getGuiaAntigo (codGuia) {
            axios.get(`${this.urlApi}/v1/guia/recolhimento/${codGuia}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Guia_' + codGuia + '.pdf';
                link.click();            
                })
            .catch((error) => {
                this.exibirErro(error);
            });

        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
